import { useEffect, useRef, useState } from 'react';
import { useRecentActions } from '@atlassian/jira-recents-store/src/index.tsx';
import usePageLoadedSubscriber from '@atlassian/jira-spa-state-controller/src/components/page-loaded-state/index.tsx';

export const InitialDataLoader = () => {
	const [, { loadRecentBoards }] = useRecentActions();

	const hasFetchedAll = useRef(false);
	const [{ hasLoaded }] = usePageLoadedSubscriber();
	const [hasTimedOut, setHasTimedOut] = useState(false);

	useEffect(() => {
		if ((hasLoaded || hasTimedOut) && !hasFetchedAll.current) {
			loadRecentBoards();
			hasFetchedAll.current = true;
		}
	}, [hasLoaded, hasTimedOut, hasFetchedAll, loadRecentBoards]);

	// given not all pages use SpaStateReady yet, we fallback to timeout
	// so we preload nav items anyway after some time
	useEffect(() => {
		let t: ReturnType<typeof setTimeout>;
		if (!hasLoaded) t = setTimeout(() => setHasTimedOut(true), 10 * 1000);
		return () => clearTimeout(t);
	}, [hasLoaded, setHasTimedOut]);

	return null;
};
